import { createSelector } from '@reduxjs/toolkit';
import { BookingI } from 'store/models/bookings/Booking';
import Booking from 'store/models/bookings/Booking';

export const curBookingsSelector = (state) => state.curBookings;

export const curBookingsBookingsSelector = createSelector(
  curBookingsSelector,
  (storeState): BookingI[] => storeState.bookings,
);

export const curBookingsFirstBookingSelector = createSelector(
  curBookingsBookingsSelector,
  (bookings) => (bookings?.length > 0 ? bookings[0] : undefined),
);
export const isMultiBookingSelector = createSelector(
  curBookingsBookingsSelector,
  (bookings) => {
    return bookings.length > 1;
  },
);

export const curBookingsBookingNoSelector = createSelector(
  curBookingsBookingsSelector,
  (bookings) => {
    return bookings.map((b) => b.bookingNo);
  },
);
export const getViewingBookingSelector = createSelector(
  curBookingsSelector,
  (curBookings): null | BookingI => {
    const { bookings, viewingIndex } = curBookings;
    if (viewingIndex === null || viewingIndex === undefined) {
      return null;
    }
    if (viewingIndex >= bookings.length) {
      console.error(
        `viewingIndex: ${viewingIndex}. bookings.length: ${bookings.length}`,
      );
      throw Error(`viewIndex out of range`);
    }
    return bookings[viewingIndex];
  },
);

export const viewingIndexSelector = createSelector(
  curBookingsSelector,
  (storeState) => storeState.viewingIndex,
);

export const mainBookingMSelector = createSelector(
  curBookingsFirstBookingSelector,
  (firstCurBooking) => {
    return firstCurBooking && new Booking(firstCurBooking);
  },
);
